import RecordReportsDownloadersRoutes from './reports-downloaders';

const RecordsRoutes = {
    ...RecordReportsDownloadersRoutes,
};

export default RecordsRoutes;
